import axios from 'axios';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const API = `${BACKEND_URL}/api`;
const apiClient = axios.create({
  baseURL: API,
  timeout: 15000,
});

const buildSiteHeaders = (siteId) => (siteId ? { 'X-Site-Id': siteId } : {});

export const toAbsoluteUrl = (path) => {
  if (!path) {
    return `${API}/resume`;
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  if (path.startsWith('//')) {
    return `https:${path}`;
  }
  return `${BACKEND_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

// Profile API
export const getProfile = async (siteId = null) => {
  try {
    const response = await apiClient.get('/profile', { headers: buildSiteHeaders(siteId) });
    return response.data;
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw error;
  }
};

export const getPortfolioData = async () => {
  try {
    const response = await apiClient.get('/portfolio');
    return response.data;
  } catch (error) {
    console.error('Error fetching portfolio data:', error);
    throw error;
  }
};

export const getResumeDownloadUrl = (profile) => {
  if (!profile?.resumeUrl && !profile?.resumeFileName) {
    return null;
  }
  return toAbsoluteUrl(profile?.resumeUrl || '/api/resume');
};

// Projects API
export const getProjects = async (featured = null, siteId = null) => {
  try {
    const params = featured !== null ? { featured } : {};
    const response = await apiClient.get('/projects', { params, headers: buildSiteHeaders(siteId) });
    return response.data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

export const getProject = async (id, siteId = null) => {
  try {
    const response = await apiClient.get(`/projects/${id}`, { headers: buildSiteHeaders(siteId) });
    return response.data;
  } catch (error) {
    console.error('Error fetching project:', error);
    throw error;
  }
};

// Skills API
export const getSkills = async (siteId = null) => {
  try {
    const response = await apiClient.get('/skills', { headers: buildSiteHeaders(siteId) });
    return response.data;
  } catch (error) {
    console.error('Error fetching skills:', error);
    throw error;
  }
};

// Experience API
export const getExperience = async (siteId = null) => {
  try {
    const response = await apiClient.get('/experience', { headers: buildSiteHeaders(siteId) });
    return response.data;
  } catch (error) {
    console.error('Error fetching experience:', error);
    throw error;
  }
};

// Education API
export const getEducation = async (siteId = null) => {
  try {
    const response = await apiClient.get('/education', { headers: buildSiteHeaders(siteId) });
    return response.data;
  } catch (error) {
    console.error('Error fetching education:', error);
    throw error;
  }
};

// Contact API
export const submitContact = async (data) => {
  try {
    const response = await apiClient.post('/contact', data);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};
